export default {
  'apiCallSend.title': 'API Send Mappings',

  'apiCallSend.form.valueSource': 'Value Source',
  'apiCallSend.form.form': 'Form',
  'apiCallSend.form.field': 'Field',
  'apiCallSend.form.variable': 'Variable',
  'apiCallSend.form.formula': 'Formula',
  'apiCallSend.form.fixedValue': 'Fixed Value',
  'apiCallSend.form.internalField': 'Internal Field',
  'apiCallSend.form.tableParameterName': 'List Parameter Name',
  'apiCallSend.form.parameterName': 'Parameter Name',
  'apiCallSend.form.sendParameterPosition': 'Send Location',
  'apiCallSend.form.parameterCodification': 'Parameter Encoding',

  'apiCallSend.form.select.FormField': 'Form / Field',
  'apiCallSend.form.select.Variable': 'Variable',
  'apiCallSend.form.select.Formula': 'Formula',
  'apiCallSend.form.select.FixedValue': 'Fixed Value',
  'apiCallSend.form.select.InternalField': 'Internal Field',
  'apiCallSend.form.select.IterationStepData': 'Iteration / Data',
  'apiCallSend.form.select.GeneratedDocument': 'Generated Document',

  'apiCallSend.form.select.FieldValue': 'Display Value',
  'apiCallSend.form.select.FieldSearchValue': 'Search Value',

  'apiCallSend.form.select.None': 'No Encoding',
  'apiCallSend.form.select.ByteArray': 'Byte Array',
  'apiCallSend.form.select.Base64String': 'Base64 String',
  'apiCallSend.form.select.ZipByteArray': 'Zip File - Byte Array',
  'apiCallSend.form.select.ZipBase64String': 'Zip File - Base64 String',
  'apiCallSend.form.select.HttpBodyBinaryData': 'Binary Encoded in Request Body',

  'apiCallSend.form.select.Header': 'Header',
  'apiCallSend.form.select.Url': 'Url',
  'apiCallSend.form.select.FormData': 'Form Data',
  'apiCallSend.form.select.BodyJson': 'Body (JSON)',
  'apiCallSend.form.select.XWwwFormUrlEncoded': 'Form URL Encoded',
  'apiCallSend.form.select.Authorization': 'Authorization',
  'apiCallSend.form.select.BodyText': 'Body (Text)',

  'apiCallSend.form.select.ProcessIdentifier': 'Process - Internal Identifier',
  'apiCallSend.form.select.ProcessName': 'Process - Name',
  'apiCallSend.form.select.ProcessGroupName': 'Process Group - Name',
  'apiCallSend.form.select.InstanceName': 'Request - Name',
  'apiCallSend.form.select.InstanceCreated': 'Request - Creation Date',
  'apiCallSend.form.select.InstanceStatus': 'Request - Status',
  'apiCallSend.form.select.ApplicantFullName': 'Applicant - Full Name',
  'apiCallSend.form.select.InstanceApprovedDate': 'Request - Approval Date',
  'apiCallSend.form.select.InstanceRejectedDate': 'Request - Rejection Date',
  'apiCallSend.form.select.ApplicantNames': 'Applicant - First Names',
  'apiCallSend.form.select.ApplicantEmail': 'Applicant - Email',
  'apiCallSend.form.select.ApplicantPosition': 'Applicant - Position',
  'apiCallSend.form.select.InstanceIdentifier': 'Request - Internal Identifier',
  'apiCallSend.form.select.InstanceLastInstanceRejectUsers': 'Request - Last Step Rejecting Users',
  'apiCallSend.form.select.InstanceLastInstanceApproversUsers':
    'Request - Last Step Approving Users',
  'apiCallSend.form.select.InstanceRejectedReason': 'Request - Rejection Reason',
  'apiCallSend.form.select.InstanceApprovalRemarks': 'Request - Approval Remarks',
  'apiCallSend.form.select.InstanceCancellationDate': 'Request - Cancellation Date',
  'apiCallSend.form.select.InstanceCancellationReason': 'Request - Cancellation Reason',
  'apiCallSend.form.select.InstanceDetailsViewUrl': 'Request - Details View Url',
};
